import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './jobsdashboard.css';


function AddJobStep2({ job, setJob })
{
    const navigate = useNavigate();

    const handleChange = (e) =>
    {
        setJob({
            ...job,
            [e.target.name]: e.target.value,
        });
    };

    const handleNext = () =>
    {
        navigate('/add-job/step-3');
    };

    return (
        <div className="add-job-step2">
            <h2>Job Details - Step 2</h2>
            <div>
                <label>Budget</label>
                <input
                    type="number"
                    name="budget"
                    value={job.budget}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>ETA</label>
                <input
                    type="date"
                    name="eta"
                    value={job.eta}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Services Required</label>
                <input
                    type="text"
                    name="servicesRequired"
                    value={job.servicesRequired}
                    onChange={handleChange}
                    required
                />
            </div>
            <button onClick={handleNext}>Next</button>
        </div>
    );
}

export default AddJobStep2;